module.exports = __webpack_public_path__ + "gif/wrong-7.gif";